import { getAppBrandFromCompany, useAppBrandState } from '@vivaldis/common'
import { hasSessionSelector, useUser } from '@vivaldis/session'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

export const AppBrandUserSync = () => {
  const hasSession = useSelector(hasSessionSelector)
  const user = useUser()
  const { resetAppBrand, setAppBrand } = useAppBrandState()

  useEffect(() => {
    if (!hasSession) {
      resetAppBrand()
      return
    }

    if (user?.company) {
      setAppBrand(getAppBrandFromCompany(user.company))
    }
  }, [hasSession, resetAppBrand, setAppBrand, user?.company])

  return null
}
